var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoldBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.72709 12.4286C3.85673 12.1641 4.10271 12 4.36967 12H9.63033C9.89729 12 10.1433 12.1641 10.2729 12.4286L11.9064 15.762C12.1786 16.3174 11.8243 17 11.2639 17H2.73614C2.17565 17 1.82136 16.3174 2.09356 15.762L3.72709 12.4286Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7271 12.4286C13.8567 12.1641 14.1027 12 14.3697 12H19.6303C19.8973 12 20.1433 12.1641 20.2729 12.4286L21.9064 15.762C22.1786 16.3174 21.8243 17 21.2639 17H12.7361C12.1757 17 11.8214 16.3174 12.0936 15.762L13.7271 12.4286Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.72709 7.42863C8.85673 7.16408 9.10271 7 9.36967 7H14.6303C14.8973 7 15.1433 7.16408 15.2729 7.42863L16.9064 10.762C17.1786 11.3174 16.8243 12 16.2639 12H7.73614C7.17565 12 6.82136 11.3174 7.09356 10.762L8.72709 7.42863Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldBar);
export default __webpack_public_path__ + "static/media/gold-bar.3cafdfc2aa2427788749f22275f3bdad.svg";
export { ForwardRef as ReactComponent };